export const MIN_SOI_COMPARABLES = 3;

export const SOI_EXPLANATION_MAX_LENGTH = 1000;
